import { priceStyles as styles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { fontFamily } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.productPrice = {
    ...styles.productPrice,
    packWrapper: {
        css: css`
            display: none;
        `,
    },
    secondaryPriceWrapper: {
        css: css`
            display: none;
        `,
    },
    savingsMessageText: {
        css: css`
            display: none;
        `,
    },
    price: {
        ...styles.productPrice?.price,
        priceText: {
            ...styles.productPrice?.price?.priceText,
            size: "21px",
            lineHeight: "25px",
            weight: 400,
            fontFamily,
        },
        unitOfMeasureText: {
            ...styles.productPrice?.price?.unitOfMeasureText,
            size: "18px",
            lineHeight: "23px",
            weight: 400,
        },
        qtyPerBaseUnitOfMeasureText: {
            css: css`
                display: none;
            `,
        },
    },
};
